import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchWithAuth } from "./config/api";
import { useAuth } from "./AuthContext";

export default function Dashboard() {
  const [profile, setProfile] = useState(null);
  const [canSendBulk, setCanSendBulk] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetchWithAuth("/api/user-profile/");

        // Only log out on actual auth errors
        if (res.status === 401 || res.status === 403) {
          if (logout) logout();
          navigate("/login", { replace: true });
          return;
        }

        if (!res.ok) {
          console.error("Profile load failed with status", res.status);
          setProfile(null);
          return;
        }

        const data = await res.json();
        setProfile(data);

        const pRes = await fetchWithAuth("/api/user/permissions/");
        if (pRes.ok) {
          const p = await pRes.json();
          setCanSendBulk(Boolean(p && p.can_send_bulk));
        }
      } catch (e) {
        console.error("Dashboard load error", e);
        // Don’t force logout on random network/server error
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [navigate, logout]);

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", padding: "2rem" }}>
        <div className="card" style={{ maxWidth: 480, margin: "2rem auto" }}>
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", padding: "2rem" }}>
      <div className="card" style={{ maxWidth: 480, margin: "2rem auto" }}>
        {/* Header + logout button */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 8,
          }}
        >
          <div>
            <h2>
              Welcome
              {profile && profile.first_name ? `, ${profile.first_name}` : ""}!
            </h2>
            <p>
              Role: <b>{(profile && profile.role) || "User"}</b>
            </p>
          </div>
          <button className="btn" type="button" onClick={logout}>
            Log out
          </button>
        </div>

        <div
          style={{
            marginTop: 12,
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          <a className="btn" href="/manager-dashboard">
            Manager Dashboard
          </a>
          {canSendBulk && (
            <a className="btn" href="/bulk-messenger">
              Bulk Messenger
            </a>
          )}
        </div>
      </div>
    </div>
  );
}